////////LIBRARY/////////
import update from 'immutability-helper'
import _, { isUndefined, cloneDeep, isNull } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const initKioskCreationSummary = {
	[ActionsTypes.RESET_DATA_CREATION_SUMMARY]: (state) => {
		return update(state, {
			initKioskCreation: {
				summary: {
					$set: { data: {}, isEditable: false },
				},
				requestId: {
					$set: null,
				},
				statusId: {
					$set: 0,
				},
				forceReadOnly: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				summary: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER_SUCCESS]: (state, payload) => {
		// Counting foldable and non foldable racks
		let d = payload.data

		if (!isUndefined(d.displayStandInfos?.displayStandConfig) && !isNull(d.displayStandInfos?.displayStandConfig)) {
			const foldedRacks = _.countBy(
				d.displayStandInfos?.displayStandConfig.displayStandTypes[1].displayStandModel,
				(o) => o.displayStandTypeModelNumber > 0
			)
			d.displayStandInfos.displayStandConfig.foldedRacks = foldedRacks.true > 0 ? foldedRacks.true : 0
			const unFoldedRacks = _.countBy(
				d.displayStandInfos?.displayStandConfig.displayStandTypes[0].displayStandModel,
				(o) => o.displayStandTypeModelNumber > 0
			)
			d.displayStandInfos.displayStandConfig.unFoldedRacks = unFoldedRacks.true > 0 ? unFoldedRacks.true : 0
		}

		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				summary: {
					data: {
						$set: d,
					},
				},
				statusId: {
					$set: d.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_CUSTOMER_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				summary: {
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_SUCCESS]: (state, _payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				statusId: {
					$set: 11, // Back call is currently not sending progressInfo object, so we have to setup manually
				},
				summary: {
					isUpdated: {
						$set: true,
					},
				},
			},
		})
	},
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				summary: {
					data: {
						$set: {},
					},
				},
			},
		}),
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS_SUCCESS]: (state, payload) => {
		let d = cloneDeep(payload.data)

		if (!isUndefined(d.displayStandInfos?.displayStandConfig) && !isNull(d.displayStandInfos?.displayStandConfig)) {
			let foldedRacks = _.countBy(
				d.displayStandInfos?.displayStandConfig.displayStandTypes[1].displayStandModel,
				(o) => o.displayStandTypeModelNumber > 0
			)
			d.displayStandInfos.displayStandConfig.foldedRacks = foldedRacks.true > 0 ? foldedRacks.true : 0
			let unFoldedRacks = _.countBy(
				d.displayStandInfos?.displayStandConfig.displayStandTypes[0].displayStandModel,
				(o) => o.displayStandTypeModelNumber > 0
			)
			d.displayStandInfos.displayStandConfig.unFoldedRacks = unFoldedRacks.true > 0 ? unFoldedRacks.true : 0
		}

		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				summary: {
					data: {
						$set: d,
					},
				},
				statusId: {
					$set: d.progressInfo.statusId,
				},
			},
		})
	},
	[ActionsTypes.GET_KIOSK_CREATION_SUMMARY_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				summary: {
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS_SUCCESS]: (state, _payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				statusId: {
					$set: 11, // Back call is currently not sending progressInfo object, so we have to setup manually
				},
				summary: {
					isUpdated: {
						$set: true,
					},
				},
			},
		})
	},
	[ActionsTypes.SET_SUMMARY_CONFIG_FINISHED_BUSINESS_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_TRIGGER_BUILD]: (state) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: true,
				},
				summary: {
					isUpdated: {
						$set: false,
					},
				},
			},
		}),
	[ActionsTypes.SET_SUMMARY_TRIGGER_BUILD_SUCCESS]: (state, _payload) => {
		return update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				statusId: {
					$set: 12, // Back call is currently not sending progressInfo object, so we have to setup manually
				},
				summary: {
					isUpdated: {
						$set: true,
					},
				},
			},
		})
	},
	[ActionsTypes.SET_SUMMARY_TRIGGER_BUILD_FAILURE]: (state, payload) =>
		update(state, {
			initKioskCreation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default initKioskCreationSummary
